function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-145.635 -1675.107)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.748,1678.03a10.689,10.689,0,0,0-9.546-1.728,10.488,10.488,0,0,0-7.047,13.557,10.339,10.339,0,0,0,6.647,6.9c3.671,1.3,8.078.268,10.237-1.706",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.213,1682.837h10.865",
  transform: "translate(-0.354 -0.125)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.213,1682.837h10.258",
  transform: "translate(-0.829 6.785)",
  fill: "none",
  stroke: "#222d3c",
  strokeLinecap: "round",
  strokeWidth: 1.5
}));

var SvgRental = function SvgRental(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.465,
    height: 22.988,
    viewBox: "0 0 23.465 22.988",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRental, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rental.842da561.svg";
export { ForwardRef as ReactComponent };